module.exports = __webpack_public_path__ + "img/surfer4.3c1b11e2.svg";